module.exports = __webpack_public_path__ + "static/media/icon-bin-purple.bbf9c305.svg";